import { useDispatch, useSelector } from 'react-redux';
import '../css/app.css'
import '../css/common.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../../store';
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';
import bank from '../bankList'

import { CountAmount, CountAmountLeft, CountSelect, DownloadBtn, TotalAmount } from '../component/btn/btn';
import List from '../component/list/list';
import { LoadingModal } from '../component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import { SquareX, SquareCheck } from 'lucide-react';

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn, SearchCrteateBtn, SearchExcelBtn, SearchInputBtn } from '../component/search/search';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import dayjs from 'dayjs';

import { changeNum, convertDateFormat } from '../common/function';

function SugiCancelManage() {
    let dispatch = useDispatch()
    let navigate = useNavigate();

    let MyData = useSelector((state) => { return state.MyData })

    const [page, setPage] = useState(1)
    const [maxFirstPage, setMaxFirstPage] = useState(20)
    const [loading, setLoading] = useState(true)

    const [message, setMessage] = useState("")
    const [listData, setListData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [combineList, setCombineList] = useState([])
    const [reload, setReload] = useState(false)

    const [listState, setListState] = useState(false)

    // 기간 포맷
    const inputRef = useRef(null);
    const pickerRef = useRef(null); // Litepicker 인스턴스를 저장할 ref

    useEffect(() => {
        pickerRef.current = new Litepicker({
            element: inputRef.current,
            lang: "ko",
            singleMode: false, // 날짜 범위 선택
            format: 'YYYY-MM-DD', // 날짜 형식
            numberOfMonths: 2, // 두 달 표시
            numberOfColumns: 2, // 두 열로 나누어 표시
            showWeekNumbers: true, // 주 번호 표시
            dropdowns: {
                minYear: 2020,
                maxYear: 2030,
                months: true,
                years: true,
            },
            setup: (picker) => {
                // 이벤트 리스너 등록
                picker.on('selected', (start, end) => {
                    setPreDate(start.format('YYYY-MM-DD'));
                    setNextDate(end.format('YYYY-MM-DD'));
                });
            }
        });

        return () => {
            pickerRef.current?.destroy(); // 컴포넌트 언마운트 시 파괴
        };
    }, []);

    // 날짜범위 포맷
    const [preDate, setPreDate] = useState(dayjs().format('YYYY-MM-DD'))
    const [nextDate, setNextDate] = useState(dayjs().format('YYYY-MM-DD'))

    useEffect(() => {
        setDateRange(dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD'))
    }, [])

    // 날짜를 설정하는 함수
    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate)
        setNextDate(endDate)
        pickerRef.current?.setDateRange(startDate, endDate);
        onSubmitSearch()
    };

    const onSubmitSearch = () => {
        setPage(1)
        setReload(e => !e)
    }

    // 검색구분 포맷
    const select4 = ["가맹점명", "가맹점아이디"]

    const [selectedValue3, setSelectedValue3] = useState("가맹점명");
    const [selectedText3, setSelectText3] = useState("")

    const handleSelectChange3 = (event) => {
        const value = event.target.value;
        setSelectedValue3(value);
    };

    const handleSelectTextChange3 = (event) => {
        const value = event.target.value;
        setSelectText3(value);
    };

    // 검색 버튼
    const submit = () => {
        setReload(e => !e)
    }

    useEffect(() => {
        dispatch(change_Current_Location("수기결제취소"))
        dispatch(changeHeaderTitle({
            mainTitle: "수기결제취소"
        }))

        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    useEffect(() => {
        ListData()
    }, [reload])

    const ListData = async () => {
        await axios.get(process.env.REACT_APP_API + "/api/sugi/history", {
            withCredentials: true,
            params: {
            }
        }).then((response) => {
            let tmp = response?.data
            // console.log(tmp)
            if (tmp?.code < 2000) {
                setListData(tmp?.data ?? [])
                setListState(e => !e)
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const tableHeaderData =
        [
            { "no": 2, "text": "거래일시", "width": "120px", "textAlign": "center" },
            { "no": 1, "text": "승인번호", "width": "100px", "textAlign": "center" },
            { "no": 3, "text": "가맹점명", "width": "120px", "textAlign": "center" },
            { "no": 4, "text": "금액", "width": "80px", "textAlign": "center" },
            { "no": 7, "text": "취소", "width": "80px", "textAlign": "center" },
        ]

    useEffect(() => {
        let tableBodyData = [];
        if (listData) {
            setCombineList(listData)

            for (let i = 0; i < listData.length; i++) {
                let data = listData[i]

                let rowData = [
                    { "no": 2, "text": data.trx_date, "width": "120px", "textAlign": "center" },
                    { "no": 1, "text": data.approval_id, "width": "100px", "textAlign": "center" },
                    { "no": 3, "text": data.mid, "width": "120px", "textAlign": "center" },
                    { "no": 4, "text": changeNum(Number(data.amt)), "width": "80px", "textAlign": "right" },
                    {
                        "no": 7, "text": (<div
                            className="flex justify-center items-center"
                            style={{ gap: "15px" }}
                        >
                            <a
                                className="delete flex items-center text-danger pointer"
                                onClick={() => onDeleteData(data.id, data.mid)}
                            >
                                <SquareX width={15} height={15} /> 취소
                            </a>
                        </div>), "width": "80px", "textAlign": "center"
                    },
                ]

                rowData.id = data.id
                tableBodyData.push(rowData);
            }
            setListState(e => !e)
            setCombineData(tableBodyData)
        }
    }, [listData, page, maxFirstPage, reload
        // selectedValue3, selectedText3,
    ])

    const onDeleteData = async (id, mid) => {
        if (window.confirm("수기결제 취소요청을 하시겠습니까?") !== true) return;
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/sugi/cancel/request",
                { id, mid },
                { withCredentials: true }
            );
            let tmp = response?.data;
            console.log(tmp)
            if (tmp?.code < 2000) {
                setReload((e) => !e);
            } else {
                setMessage({ msg: "수기결제 요청 거절 실패" });
            }
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className="content" id="contents">
            {loading ? <LoadingModal /> : ""}
            <MessageModal message={message} />
            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <SearchDate
                        type={"기간"}
                        inputRef={inputRef}
                        setDateRange={setDateRange}
                        preDate={preDate}
                        nextDate={nextDate}
                    />
                    {/* {<SearchSelectText type={"검색구분"} selectData={select4} handleSelectChange={handleSelectChange3} selectedValue={selectedValue3} handleSelectTextChange={handleSelectTextChange3} selectedText={selectedText3} btnText={"검색"} onClick={() => submit()} />} */}

                </form>
            </div>
            <div className="intro-y box intro-padding" >
                <div style={{ width: "100%", maxWidth:"600px" }}>
                    <List
                        tableHeaderData={tableHeaderData}
                        tableBodyData={listData?.totCnt ?? 0}
                        filter_tableBodyData={combineData}
                        page={page}
                        setPage={setPage}
                        maxFirstPage={maxFirstPage}
                        listType={true}
                        listState={listState}
                    />
                </div>
            </div>
        </div>
    )
}

export default SugiCancelManage